import React from 'react';
import CardHeader from "../../components/Card/CardHeader";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import AiDesignsTable from "./AiDesignsTable";
 
export default function AiDesigns() {
    const classes = {};

    const loadTypeButtons = () => {
        return null;
    };

    return (
        <GridContainer>
            <GridItem>
                <Card>
                    <CardHeader>
                        <h4 className={classes.cardTitle}>AI Designs</h4>
                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem>
                                <AiDesignsTable/>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
}